import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_CHEMIST_ROB_VALUES_REPORT} from '@app/navigations/RoutePathConstant';

const ROBValueForChemistReport = lazy(() =>
  import('../../../screens/ROBValueForChemistReport')
    .then(module => ({default: module.ROBValueForChemistReport})));

const ROBValueForChemistReportNavigation = [
  {
    path: ROUTE_CHEMIST_ROB_VALUES_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ROBValueForChemistReport />
      </Suspense>
    ),
  },
];

export default ROBValueForChemistReportNavigation;
